import React, { memo, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import Traductor from '../Traductor';
import AuctionCard from '../auctions/AuctionCard';
import CustomMessage from '../shared/CustomMessage';

function AuctionsList({ history, loading, listItems, type, serverTime }) {
    const t = new Traductor();
    const printAutionCards = () => {
        if (loading) return null;

        if (listItems && listItems.length > 0) {
            return (
                <div
                    className="u-mt u-p-none c-cards-slider-container  js-slider"
                    auctionstype={type}
                >
                    <div className="c-cards-slider  js-slider__element ">
                        {listItems.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    className="js-slider__item  c-cards-slider__item"
                                >
                                    <div className="c-cards-slider__card-wrapper">
                                        <AuctionCard
                                            item={item}
                                            history={history}
                                            type={type}
                                            serverTime={serverTime}
                                        ></AuctionCard>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="js-slider__controls  c-cards-slider__controls">
                        <button
                            title=""
                            className="js-slider__button--prev  c-icon  c-icon--[semantic-back]"
                            type="button"
                        ></button>
                        <span className="js-slider__counter  c-cards-slider__counter"></span>
                        <button
                            title=""
                            className="js-slider__button--next  c-icon  c-icon--[semantic-forward]"
                            type="button"
                        ></button>
                    </div>
                </div>
            );
        } else {
            let options = {
                body: t.getTraduction(
                    type == 'upcoming'
                        ? 'SinProximasActivas'
                        : 'SinSubastasActivas'
                ),
                icon: 'no-vehicles',
            };
            return <CustomMessage options={options}></CustomMessage>;
        }
    };

    const printSkeleton = () => {
        if (!loading) return null;

        let counter = 4;
        let listItems = [];

        while (counter > 0) {
            listItems.push(
                <div
                    key={counter}
                    className="js-slider__item  c-cards-slider__item"
                >
                    <div className="c-cards-slider__card-wrapper">
                        <AuctionCard
                            item={{ skeleton: true }}
                            history={history}
                            disabled="true"
                            serverTime={serverTime}
                        ></AuctionCard>
                    </div>
                </div>
            );
            counter--;
        }

        return (
            <div className="u-mt u-p-none c-cards-slider-container js-slider">
                <div
                    className={
                        'c-cards-slider  js-slider__element c-card--inactive'
                    }
                >
                    {listItems.map(item => {
                        return item;
                    })}
                </div>
                <div className="js-slider__controls  c-cards-slider__controls">
                    <button
                        title=""
                        className="js-slider__button--prev  c-icon  c-icon--[semantic-back]"
                        type="button"
                    ></button>
                    <span className="js-slider__counter  c-cards-slider__counter"></span>
                    <button
                        title=""
                        className="js-slider__button--next  c-icon  c-icon--[semantic-forward]"
                        type="button"
                    ></button>
                </div>
            </div>
        );
    };

    return (
        <Fragment>
            {printSkeleton()}
            {printAutionCards()}
        </Fragment>
    );
}

export default memo(withRouter(AuctionsList));
